module.exports = __webpack_public_path__ + "static/media/HAKKA-BUSD.ca45ff2b.svg";